export const LOCALE_UA = "ua";
export const LOCALE_EN = "en";